import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HhsgSharedApplication } from '../models/application.model';
import { HhsgSharedClientApplication } from '../models/client-application.model';
import { HhsgSharedIdentityServerClient } from '../models/identity-server-client.model';
import { HhsgSharedConfigService } from './config.service';
import { HhsgSharedHttpService } from './http.service';
import {Observable} from "rxjs";
import {take} from "rxjs/operators";

@Injectable()
export class HhsgSharedApplicationsService {
    private readonly _apiServer: string;
    private readonly _controllerName: string = 'Applications';

    constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) {
        this._apiServer = _configService.appSettings.stsServer;
    }

    public getChildUrlWithApplicationSpecificToken(name:string, applicationId: number, childApplicationUserId: number) : Observable<string> {
      const params = new HttpParams({
        fromObject: {
          sourceApplicationId: `0`,
          applicationIdToRedirect: `${applicationId}`,
          childApplicationUserId: `${childApplicationUserId}`,
        }
      });

      return this._httpService.doGetRequestWithParams<string>(this._apiServer, this._controllerName, 'RedirectToApplication', params);
    }

    public openChildUrlWithApplicationSpecificToken(name:string, applicationId: number, childApplicationUserId: number) {
      this.getChildUrlWithApplicationSpecificToken(name, applicationId, childApplicationUserId).pipe(take(1)).subscribe(
        url => window.open(url, '_self')
      );
    }

    public async getApplications(): Promise<HhsgSharedApplication[]> {
        return this._httpService.doGetRequestAsync<HhsgSharedApplication[]>(this._apiServer, this._controllerName, 'Get');
    }

    public async getApplicationsByUserId(userId: number): Promise<any> {
        const params = new HttpParams();
        params.append('userId', userId.toString());

        return await this._httpService.doApiGetRequestWithParamsAsync(this._apiServer, this._controllerName, 'User', params);
    }

    public async getClientApplications(clientId: number): Promise<HhsgSharedClientApplication[]> {
        return await this._httpService.doGetRequestAsync<HhsgSharedClientApplication[]>(this._apiServer, this._controllerName, `Client/${clientId}`);
    }
    public async getClientApplicationsForImporter(clientId: number, applicationAbbreviation: string): Promise<HhsgSharedClientApplication[]> {
      return await this._httpService.doGetRequestAsync<HhsgSharedClientApplication[]>(this._apiServer, this._controllerName, `GetApplicationsByApplicationAbbreviation/${clientId}/${applicationAbbreviation}`);
    }

    public async getClientApplicationsByClientIds(clientIds: number[]): Promise<HhsgSharedClientApplication[]> {
        let queryParams = new HttpParams()
        .set("clientIds",clientIds.toString());
        return await this._httpService.doApiGetRequestWithParamsAsync<HhsgSharedClientApplication[]>(this._apiServer, this._controllerName, `GetClientApplicationsByClientIds`,queryParams);
    }

    public async getIdentityServerClients(): Promise<HhsgSharedIdentityServerClient[]> {
        return await this._httpService.doGetRequestAsync<HhsgSharedIdentityServerClient[]>(this._apiServer, this._controllerName, `GetAllIdentityServerClients`);
    }

    public async saveClientApplications(clientApps: HhsgSharedClientApplication[]): Promise<any> {
      return this._httpService.doPostRequestAsync(this._apiServer, this._controllerName, 'UpdateClientApplications', clientApps);
	  }

    public async upsertApplication(application: HhsgSharedApplication): Promise<any> {
        return await this._httpService.doPostRequestAsync<HhsgSharedApplication, HhsgSharedApplication>(
            this._apiServer,
            this._controllerName,
            'UpsertApplication',
            application);
    }

    public async upsertIdentityServerClient(identityServerClient: HhsgSharedIdentityServerClient): Promise<any> {
        return await this._httpService.doPostRequestAsync<HhsgSharedIdentityServerClient, HhsgSharedIdentityServerClient>(
            this._apiServer,
            this._controllerName,
            'UpsertIdentityServerClient',
            identityServerClient);
    }
}
